/* src/app/admin/template-list/template-list.component.scss */
/*# sourceMappingURL=template-list.component-TEJ3DRQT.css.map */
